// components/SchoolHeader.js
import React from 'react';
import useSchoolParams from '../hooks/useSchoolParams';
import { Building2, Layers } from 'lucide-react';

const SchoolHeader = () => {
  const { schoolInfo, loading, error } = useSchoolParams();

  if (loading) {
    return (
      <div className="flex items-center space-x-4 animate-pulse">
        <div className="w-12 h-12 bg-white/20 rounded-lg"></div>
        <div>
          <div className="h-5 bg-white/20 rounded w-32 mb-1"></div>
          <div className="h-3 bg-white/20 rounded w-24 mb-1"></div>
          <div className="h-3 bg-white/20 rounded w-28"></div>
        </div>
      </div>
    );
  }

  if (error) {
    console.warn('Erreur paramètres école, utilisation des valeurs par défaut:', error);
  }

  const displayName = schoolInfo?.name || 'Mon École';
  const displaySubtitle = schoolInfo?.sous_titre || 'Établissement Scolaire';
  const displaySlogan = schoolInfo?.slogan || '';
  const displayInitials = schoolInfo?.logo_initiales || 'EC';
  const displayColor = schoolInfo?.couleur_logo || '#246990';
  const displayLogoUrl = schoolInfo?.logo_url;
  
  // ✅ INFOS TENANT
  const tenantSubdomain = schoolInfo?.tenant_subdomain;
  const tenantDisplayName = schoolInfo?.tenant_display_name;
  const showTenant = tenantDisplayName && 
                     tenantSubdomain !== 'www' && 
                     tenantSubdomain !== 'unknown' &&
                     tenantSubdomain !== 'gestion_scolaire';

  return (
    <div className="flex items-center space-x-4">
      {/* Container logo avec fond blanc */}
      <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center p-0.5 shadow-sm">
        {displayLogoUrl ? (
          <img 
            src={displayLogoUrl} 
            alt="Logo école"
            className="w-full h-full object-contain rounded"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        
        {/* Initiales en fallback */}
        <div 
          className="w-full h-full flex items-center justify-center font-bold text-lg"
          style={{ 
            color: displayColor,
            display: displayLogoUrl ? 'none' : 'flex'
          }}
        >
          {displayInitials}
        </div>
      </div>

      {/* Informations textuelles */}
     
    <div>
      {/* ✅ NOM DE L'ÉCOLE + TENANT À DROITE */}
      <div className="flex items-center gap-2">
        {/* Nom de l'école À GAUCHE */}
        <div className="text-xl font-bold text-white leading-tight">
          {displayName}
        </div>
        
        {/* TENANT À DROITE */}
        {showTenant && (
          <>
            <span className="text-white/50"></span>
            <div className="flex items-center gap-1 bg-blue-500/20 px-2 py-0.5 rounded">
             
              <span className="text-xs font-semibold text-blue-100">
                {tenantDisplayName}
              </span>
            </div>
          </>
        )}
      </div>
      
      {/* Sous-titre */}
      <div className="text-sm text-white/90 leading-tight">
        {displaySubtitle}
      </div>
      
      {/* Slogan */}
      {displaySlogan && (
        <div className="text-xs text-white/80 leading-tight">
          {displaySlogan}
        </div>
      )}
    </div>

    </div>
  );
};

export default SchoolHeader;